import { useState } from 'react';

import { ConfigPublic } from '@/common/config.public';
import { OPTIMOVE_SDK_ENABLED } from '@/common/hooks/useOptimove/useOptimove.const';
import useScript from '@/common/hooks/useScript/useScript';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const optimoveSDK: any;

export const useOptimove = (): { optimoveSDKInitialized: boolean; optimoveSDKEnabled: boolean } => {
  const optimoveSDKEnabled = ConfigPublic.OptimoveSdkEnabled === OPTIMOVE_SDK_ENABLED;
  const [sdkInitialized, setSdkInitialized] = useState(false);

  const status = useScript(
    `https://sdk-cdn.optimove.net/websdk/sdk-v${ConfigPublic.OptimoveSdkVersion}.js`,
    {
      removeOnUnmount: false,
      shouldPreventLoad: !optimoveSDKEnabled,
    },
  );

  if (status === 'ready' && !sdkInitialized) {
    optimoveSDK.initialize(
      ConfigPublic.OptimoveSdkToken,
      ConfigPublic.OptimoveSdkVersion,
      () => {
        setSdkInitialized(true);
        window.optimoveSDKInitialized = true;
        window.optimoveTrackingItemsCount = 5;
        window.optimoveSDKEnabled = optimoveSDKEnabled;
      },
      'info',
    );
  }

  return {
    optimoveSDKInitialized: sdkInitialized,
    optimoveSDKEnabled,
  };
};
